// this is a no follow no index page for Advisory Vehicle "advisory" and "advisory-hidden".

import * as React from "react"
import { useState, useEffect, useRef } from "react"
import { graphql, Link } from "gatsby"
import Helmet from "react-helmet"
import { Layout } from "../../components/layout"
import {
  saumlContainer,
  testmaincontainer,
  imgPad,
  test,
  testcontainer,
  PDPAuthor,
  ArtworkName,
  specification,
  pdpUrl,
  pdpImageslider,
  pdpSubheading,
  bluedDarkbutton,
  thumbnailSliderWrapper,
  containerMedia,
  colMedia,
  productContainer,
  colProduct,
  hrSpec,
  soldOut,
  auctionCardsContainer,
  auctionCard,
  emaContainer,
  rowOne,
  columnOne,
  columnTwo,
  auctionImage,
  auctionData,
  smalpad,
  autionTitle,
} from "../products/single-product.module.css"
import { title, sectionMandatPad } from "../../pages/index.module.css"
import { button } from "../../components/buttons/product-button.module.css"
import ShopifyRichText from "../../utils/ShopifyRichTextToHTML"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { tooltip, tooltiptext, tooltipImage } from "./all-products.module.css"
import { ProductButton } from "../../components/buttons/product-button"
import { DarkButton } from "../../components/buttons/dark-button"
import { Seo } from "../../components/seo"
import { useSeekaConverge } from "@seeka-labs/converge-react"
import FsLightbox from "fslightbox-react"

export default function AdvisoryContent({ data, pageContext }) {
  const [toggler, setToggler] = useState(false)
  const [lightboxSources, setLightboxSources] = useState([])

  const handleImageClick = (imageUrl) => {
    setLightboxSources([imageUrl])
    setToggler(!toggler)
  }

  // Render the component content
  const product = data.storefront.products.nodes.find(
    (node) => node.handle === pageContext.handle
  )

  if (!product) {
    return (
      <Layout>
        <p>Product not found.</p>
      </Layout>
    )
  }

  const artists = data.storefront.metaobjects.edges
  const productVendor = product.vendor

  const productMetafields = product.metafields.filter(
    (metafield) => metafield !== null
  )
  productMetafields.forEach((metafield) => {
    if (
      metafield &&
      metafield.reference &&
      metafield.reference.fields &&
      metafield.reference.fields.length > 0
    ) {
      const textValue = metafield.reference.fields[0]?.value

      // console.log("Text Value:", textValue);

      const imageReference = metafield.reference.fields.find(
        (field) => field.reference && field.reference.id.includes("MediaImage")
      )
      const videoReference = metafield.reference.fields.find(
        (field) => field.reference && field.reference.id.includes("Video")
      )

      if (
        imageReference &&
        imageReference.reference &&
        imageReference.reference.image
      ) {
        const imageURL = imageReference.reference.image.url
        // console.log("Image URL:", imageURL);
      }

      if (
        videoReference &&
        videoReference.reference &&
        videoReference.reference.sources &&
        videoReference.reference.sources.length > 0
      ) {
        const videoURL = videoReference.reference.sources[0].url
        const videoAlt = videoReference.reference.alt
        // console.log("Video URL:", videoURL);
        // console.log("Video ALT:", videoAlt);
      }
    }
  })

  // Filter the artist list based on matching names with product vendor
  const matchingArtists = artists.filter(({ node }) => {
    return node.artistname.value === productVendor
  })

  const matchingCollection = data.storefront.collections.nodes.find(
    (collection) => {
      return collection.title.toLowerCase() === productVendor.toLowerCase()
    }
  )

  if (matchingCollection && matchingCollection.metafields) {
    const pdfFileMetafield = matchingCollection.metafields.find(
      (metafield) => metafield && metafield.key === "pdf" // Check for "pdf" key
    )

    if (
      pdfFileMetafield &&
      pdfFileMetafield.reference &&
      pdfFileMetafield.reference.pdfFile &&
      pdfFileMetafield.reference.pdfFile.reference
    ) {
      // const pdfFileUrl = pdfFileMetafield.reference.pdfFile.reference.url
      // Log the PDF file URL
      //  console.log("PDF File URL:", pdfFileUrl)
    }
  }

  // console.log("Matching Collection:", matchingCollection);

  // Extract exhibition data
  const exhibitions = matchingArtists
    .map(({ node }) => {
      return node.exhibition?.references?.nodes || []
    })
    .flat()

  // Filter out nodes with exactly 2 fields
  const exhibitionsWithTwoFields = exhibitions.filter((exhibition) => {
    return exhibition.fields.length === 2
  })

  const { metafield } = product
  // console.log(productMetafields)
  // console.log(
  //   "product.metafield?.reference?.fields[0]?.value:",
  //   product.metafield?.reference?.fields[0]?.value
  // )

  // const [selectTemplate, setSelectTemplate] = useState('');

  // useEffect(() => {
  //   // Fetch and set the select_template value when component mounts
  //   if (product && product.metafield && product.metafield.value) {
  //     setSelectTemplate(product.metafield.value);
  //   }
  // }, [product]);

  let selectTemplateValue = null

  if (
    metafield &&
    metafield.reference &&
    metafield.reference.fields &&
    metafield.reference.fields.length > 0
  ) {
    selectTemplateValue = metafield.reference.fields[0].value
  }

  const converge = useSeekaConverge()

  const handleBrochureClick = () => {
    const productTitle = product.title
    const AuthorName =
      matchingArtists.length > 0
        ? matchingArtists[0].node.artistname.value
        : "Unknown Author"
    converge.track.viewContentItem({
      contentName: `Brochure PDF downloaded for ${AuthorName} - ${productTitle}`,
    })
  }

  useEffect(() => {
    // Execute the viewProduct function with the product data
    if (typeof window !== "undefined") {
      const product = data.storefront.products.nodes.find(
        (node) => node.handle === pageContext.handle
      )

      if (!product) {
        console.error("Product not found.")
        return
      }

      // Extract relevant product data
      const { title, variants, vendor, totalInventory } = product

      // Assuming there's only one variant for simplicity, you might need to adjust this
      const variant = variants.nodes[0]
      const productIdentifier = product.id.replace("gid://shopify/Product/", "")
      const variantIdentifier = variant.id.replace(
        "gid://shopify/ProductVariant/",
        ""
      )

      // Define the data to pass to converge.track.viewProduct()
      const productData = {
        currencyCode: "SGD",
        productIdentifier: productIdentifier,
        variantIdentifier: variantIdentifier,
        sku: variant.sku,
        lineItemIdentifier: "",
        productName: title,
        // variantName: variant.title,
        categoryName: selectTemplateValue,
        brandName: vendor,
        unitPrice: product.priceRange.maxVariantPrice.amount,
        // quantity: 1,
        totalInventory: product.totalInventory,
        totalDiscount: 0,
      }

      // Execute the viewProduct function with the product data
      converge.track.viewProduct(productData)
    }
  }, [data, pageContext, converge])

  const advisoryInfo = product.advisoryInformation[0]?.reference

  // Check if matchingCollection is found
  // console.log("matchingCollection:", matchingCollection)

  // Ensure matchingCollection and its metafields are properly checked
  const auctionResultsMetafield =
    matchingCollection && matchingCollection.metafields
      ? matchingCollection.metafields.find(
          (metafield) => metafield && metafield.key === "auction_results"
        )
      : null

  // Extract the auction results from the metafield
  const auctionResults =
    auctionResultsMetafield && auctionResultsMetafield.references
      ? auctionResultsMetafield.references.nodes
      : []

  const auctionResultsLength = auctionResults.length
  const slidesToShowCount =
    auctionResultsLength === 1
      ? 1
      : auctionResultsLength === 2
      ? 2
      : auctionResultsLength === 3
      ? 3
      : 4
  // Check the auction results
  // console.log("auctionResults:", auctionResults)

  const [sliderContainerStyle, setSliderContainerStyle] = useState({})
  const [quantity, setQuantity] = React.useState(1)
  const [nav1, setNav1] = useState(null)
  const [nav2, setNav2] = useState(null)
  const sliderRef1 = useRef(null)
  const sliderRef2 = useRef(null)

  useEffect(() => {
    setNav1(sliderRef1.current)
    setNav2(sliderRef2.current)
  }, [])

  const productImages = product.images.nodes
  const showThumbnailSlider = productImages.length > 1

  // Custom component for Previous Arrow
  const PrevArrow = (props) => {
    const { onClick } = props
    return (
      <button onClick={onClick} className="custom-slick-prev">
        &larr;
      </button>
    )
  }

  // Custom component for Next Arrow
  const NextArrow = (props) => {
    const { onClick } = props
    return (
      <button onClick={onClick} className="custom-slick-next">
        &rarr;
      </button>
    )
  }

  const productSliderSettings = {
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    dots: true,
    speed: 1000,
    autoplaySpeed: 10000,
    adaptiveHeight: true,
    draggable: true,
    fade: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    arrows: false,
    asNavFor: showThumbnailSlider ? nav2 : null,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          infinite: true,
        },
      },
    ],
  }

  const thumbnailSliderSettings = {
    slidesToShow: productImages.length === 2 ? 2 : 3,
    slidesToScroll: 1,
    asNavFor: showThumbnailSlider ? nav1 : null,
    swipeToSlide: true,
    focusOnSelect: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: productImages.length === 2 ? 2 : 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 0,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 0,
        },
      },
    ],
  }

  const exhibitionsliderSettings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    adaptiveHeight: false,
    dots: false,
    speed: 1000,
    autoplaySpeed: 10000,
    draggable: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          infinite: true,
        },
      },
    ],
  }

  const auctionSliderSettings = {
    slidesToShow: slidesToShowCount,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    dots: false,
    speed: 1000,
    autoplaySpeed: 1000,
    draggable: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 2400,
        settings: {
          slidesToShow: slidesToShowCount,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: auctionResultsLength >= 4 ? 3 : slidesToShowCount,
          slidesToScroll: 1,
          dots: false,
          infinite: false,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: auctionResultsLength >= 3 ? 3 : slidesToShowCount,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 1048,
        settings: {
          slidesToShow: auctionResultsLength >= 2 ? 1 : slidesToShowCount,
          slidesToScroll: 1,
          dots: false,
          infinite: true,
        },
      },
      {
        breakpoint: 738,
        settings: {
          slidesToShow: auctionResultsLength >= 2 ? 1 : slidesToShowCount,
          slidesToScroll: 1,
          dots: true,
          infinite: true,
        },
      },
    ],
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{product.title}</title>
      </Helmet>
      <div>
        <div className={sectionMandatPad}>
          <div className={saumlContainer}>
            <div className={productContainer}>
              <div className={colProduct}>
                {product.images.nodes.length > 0 && (
                  <div className={pdpImageslider}>
                    <Slider {...productSliderSettings} ref={sliderRef1}>
                      {product.images.nodes.map((image, index) => (
                        <div className={testmaincontainer}>
                          <div className={testcontainer}>
                            <img
                              className={test}
                              src={image.url}
                              alt={image.altText || "product image"}
                            />
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                )}

                {showThumbnailSlider && (
                  <>
                    <br />
                    <br />
                    <Slider
                      {...thumbnailSliderSettings}
                      ref={sliderRef2}
                      className={thumbnailSliderWrapper}
                    >
                      {productImages.map((image, index) => (
                        <div key={index}>
                          <img
                            src={image.url}
                            alt={image.altText || "thumbnail image"}
                            className={imgPad}
                          />
                        </div>
                      ))}
                    </Slider>
                  </>
                )}
              </div>
              <div className={colProduct}>
                <div>
                  {matchingArtists.map(({ node }) => (
                    <div key={node.handle}>
                      <h1 className={PDPAuthor}>{node.artistname.value}</h1>
                    </div>
                  ))}

                  <h4 className={ArtworkName}>{product.title}</h4>
                  {product.subheading &&
                    product.subheading.reference &&
                    product.subheading.reference.fields[0]?.value && (
                      <p className={pdpSubheading}>
                        {product.subheading.reference.fields[0].value}
                      </p>
                    )}

                  <div>
                    {metafield && metafield.reference && (
                      <>
                        <p className={specification}>
                          Discover more with: <em>Art Works Advisory</em> &nbsp;
                          <span className={tooltip}>
                            <img
                              src="https://cdn.shopify.com/s/files/1/0823/1606/7107/files/Tooltip.svg?v=1709266734"
                              className={tooltipImage}
                              alt="tooltip"
                            />
                            <span className={tooltiptext}>
                              Art Works Advisory offers seasoned expertise and
                              access for sophisticated art collectors and
                              investors.
                            </span>
                          </span>{" "}
                        </p>
                      </>
                    )}
                  </div>

                  {/* {product.priceRange && product.priceRange.maxVariantPrice && (
                            <p>${product.priceRange.maxVariantPrice.amount.toString().split('.')[0]}{' '}
                            {product.priceRange.maxVariantPrice.currencyCode}</p>
                          )} */}

                  {product.priceRange && product.priceRange.maxVariantPrice && (
                    <p>
                      $
                      {new Intl.NumberFormat("en-US", {
                        currency:
                          product.priceRange.maxVariantPrice.currencyCode,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(product.priceRange.maxVariantPrice.amount)}{" "}
                      {product.priceRange.maxVariantPrice.currencyCode}
                    </p>
                  )}

                  <hr className={hrSpec} />

                  {product.dimension &&
                    product.dimension.reference &&
                    product.dimension.reference.fields[0]?.value && (
                      <p>{product.dimension.reference.fields[0].value}</p>
                    )}

                  {product.medium &&
                    product.medium.references &&
                    product.medium.references.nodes.length > 0 && (
                      <div>
                        <p>
                          {product.medium.references.nodes.map(
                            (medium, index, array) => (
                              <React.Fragment key={index}>
                                <span>{medium.fields[0].value}</span>
                                {index < array.length - 2 ? ", " : ""}
                                {index === array.length - 2 && array.length > 1
                                  ? " and "
                                  : ""}
                              </React.Fragment>
                            )
                          )}
                        </p>
                      </div>
                    )}

                  {product.artworksubstrate &&
                    product.artworksubstrate.reference &&
                    product.artworksubstrate.reference.fields[0]?.value && (
                      <p>
                        {product.artworksubstrate.reference.fields[0].value}
                      </p>
                    )}

                  {product.metafield?.reference?.fields[0]?.value ===
                    "Advisory" ||
                  product.metafield?.reference?.fields[0]?.value ===
                    "Advisory-Hidden" ? (
                    ""
                  ) : (
                    <>
                      {product.Locationview &&
                        product.Locationview.length > 0 && (
                          <div>
                            <div>
                              {product.Locationview.map((location) => (
                                <div key={location?.id}>
                                  {location?.reference.fields[1]?.value && (
                                    <Link
                                      to={location.reference.fields[1].value}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Available to view at{" "}
                                      <span className={pdpUrl}>
                                        {location.reference.fields[0]?.value}
                                      </span>
                                    </Link>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                    </>
                  )}

                  {advisoryInfo && (
                    <div>
                      {advisoryInfo.framingData &&
                        advisoryInfo.framingData.value && (
                          <p>
                            <strong>Framing:</strong> $
                            {advisoryInfo.framingData.value}
                          </p>
                        )}

                      {advisoryInfo.valuationsData &&
                        advisoryInfo.valuationsData.value && (
                          <p>
                            <strong>Valuations:</strong> $
                            {advisoryInfo.valuationsData.value}
                          </p>
                        )}

                      {advisoryInfo.managementFeeData &&
                        advisoryInfo.managementFeeData.value && (
                          <p>
                            <strong>Management Fees:</strong> $
                            {advisoryInfo.managementFeeData.value}
                          </p>
                        )}

                      {advisoryInfo.valueOfWorkData &&
                        advisoryInfo.valueOfWorkData.value && (
                          <p>
                            <strong>Value of Work:</strong> $
                            {advisoryInfo.valueOfWorkData.value}
                          </p>
                        )}

                      {advisoryInfo.totalCostofPortfolioIncludingSundriesData &&
                        advisoryInfo.totalCostofPortfolioIncludingSundriesData
                          .value && (
                          <p>
                            <strong>
                              Total Cost of Portfolio Including Sundries:
                            </strong>{" "}
                            $
                            {
                              advisoryInfo
                                .totalCostofPortfolioIncludingSundriesData.value
                            }
                          </p>
                        )}

                      {advisoryInfo.rentalTermsData &&
                        advisoryInfo.rentalTermsData.value && (
                          <p>
                            <strong>Rental Terms:</strong>
                            {advisoryInfo.rentalTermsData.value}
                          </p>
                        )}

                      {advisoryInfo.rentalreturnData &&
                        advisoryInfo.rentalreturnData.value && (
                          <p>
                            <strong>Rental Return:</strong>{" "}
                            {advisoryInfo.rentalreturnData.value}
                          </p>
                        )}
                    </div>
                  )}
                  <hr className={hrSpec} />
                  <br />
                  {matchingArtists.map(({ node }) => (
                    <div key={node.handle}>
                      <Link
                        to={`/artists/${node.handle}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={button}
                      >
                        View Artist
                      </Link>
                    </div>
                  ))}
                  <br />
                  <br />
                  <div>
                    {matchingCollection &&
                      matchingCollection.metafields &&
                      matchingCollection.metafields.length > 0 && (
                        <>
                          {matchingCollection.metafields.some(
                            (metafield) =>
                              metafield &&
                              metafield.key === "pdf" &&
                              metafield.reference?.pdfFile?.reference
                          ) && (
                            <div>
                              <Link
                                to={
                                  matchingCollection.metafields.find(
                                    (metafield) =>
                                      metafield && metafield.key === "pdf"
                                  ).reference.pdfFile.reference.url
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                className={button}
                                onClick={handleBrochureClick}
                              >
                                Download Profile
                              </Link>
                            </div>
                          )}
                        </>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {product.descriptionHtml && product.descriptionHtml.length > 0 && (
            <div className={saumlContainer}>
              <h1 className={title}>ARTWORK DESCRIPTION</h1>
              <ShopifyRichText richTextData={product.descriptionHtml} />
            </div>
          )}

          {matchingArtists.length > 0 && (
            <div className={saumlContainer}>
              <h1 className={title}>ARTIST BIO</h1>
              <div>
                {matchingArtists.map(({ node }) => (
                  <div key={node.handle}>
                    {node.artistdescription && (
                      <div>
                        <ShopifyRichText
                          richTextData={node.artistdescription.value}
                        />
                        <Link
                          to={`/artists/${node.handle}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={bluedDarkbutton}
                        >
                          READ MORE &rarr;
                        </Link>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {productMetafields && productMetafields.length > 0 && (
          <div className={saumlContainer}>
            <h1 className={title}>WHAT ART WORKS SAY</h1>
            <div className={containerMedia}>
              <div className={colMedia}>
                {productMetafields.map(
                  (metafield) =>
                    metafield &&
                    metafield.reference && (
                      <div key={metafield.id}>
                        <ShopifyRichText
                          richTextData={metafield.reference.fields[0]?.value}
                        />
                      </div>
                    )
                )}
              </div>
              <div className={colMedia}>
                {productMetafields.map(
                  (metafield) =>
                    metafield &&
                    metafield.reference && (
                      <div key={metafield.id}>
                        {metafield.reference.fields.some(
                          (field) =>
                            field.reference &&
                            field.reference.id.includes("MediaImage")
                        ) && (
                          <div>
                            <img
                              src={
                                metafield.reference.fields.find(
                                  (field) =>
                                    field.reference &&
                                    field.reference.id.includes("MediaImage")
                                ).reference.image.url
                              }
                            />
                          </div>
                        )}
                        {metafield.reference.fields.some(
                          (field) =>
                            field.reference &&
                            field.reference.id.includes("Video")
                        ) && (
                          <div>
                            <video controls>
                              <source
                                src={
                                  metafield.reference.fields.find(
                                    (field) =>
                                      field.reference &&
                                      field.reference.id.includes("Video")
                                  ).reference.sources[0].url
                                }
                                type="video/mp4"
                                alt={
                                  metafield.reference.fields.find(
                                    (field) =>
                                      field.reference &&
                                      field.reference.id.includes("Video")
                                  ).reference.alt
                                }
                              />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        )}
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
        )}

        {product.metafield?.reference?.fields[0]?.value === "Advisory" ||
        product.metafield?.reference?.fields[0]?.value === "Advisory-Hidden" ? (
          <>
            {matchingCollection &&
              matchingCollection.metafields &&
              matchingCollection.metafields.length > 0 && (
                <div>
                  {matchingCollection.metafields.some(
                    (metafield) =>
                      metafield &&
                      metafield.key === "auction_results" &&
                      metafield.references?.nodes.length > 0
                  ) && (
                    <div className={emaContainer}>
                      <h1 className={title}>Auction results</h1>
                      <br />
                      {matchingCollection.metafields.map((metafield) => {
                        if (metafield && metafield.key === "auction_results") {
                          const references = metafield.references
                          if (
                            references &&
                            references.nodes &&
                            references.nodes.length > 0
                          ) {
                            const sortedNodes = references.nodes
                              .filter((node) => node.fields[5]?.value)
                              .sort((a, b) => {
                                const dateA = new Date(a.fields[5].value)
                                const dateB = new Date(b.fields[5].value)
                                return dateB - dateA
                              })
                            // console.log(sortedNodes)
                            return (
                              <div key={metafield.id}>
                                <Slider {...auctionSliderSettings}>
                                  {sortedNodes.map((node) => (
                                    <div className={auctionCardsContainer}>
                                      <div
                                        key={node.id}
                                        className={auctionCard}
                                      >
                                        <div>
                                          <h3 className={autionTitle}>
                                            {node.fields[3].value}
                                          </h3>
                                        </div>
                                        <div className={rowOne}>
                                          <div className={columnOne}>
                                            {node.fields[4]?.reference?.image
                                              ?.url && (
                                              <img
                                                src={
                                                  node.fields[4].reference.image
                                                    ?.url
                                                }
                                                alt="Auction Image"
                                                className={auctionImage}
                                                onClick={() =>
                                                  handleImageClick(
                                                    node.fields[4].reference
                                                      .image.url
                                                  )
                                                }
                                              />
                                            )}
                                          </div>
                                          <div className={columnTwo}>
                                            <p className={auctionData}>
                                              <span style={{ fontWeight: 700 }}>
                                                Hammer Price:
                                              </span>
                                              <br />
                                              <span
                                                style={{ color: "#495057" }}
                                              >
                                                {node.fields[1].value}
                                              </span>
                                            </p>
                                            <p className={auctionData}>
                                              <span style={{ fontWeight: 700 }}>
                                                Estimated Price:
                                              </span>
                                              <br />
                                              <span
                                                style={{ color: "#495057" }}
                                              >
                                                {node.fields[0].value}
                                              </span>
                                            </p>
                                            <p className={auctionData}>
                                              <span style={{ fontWeight: 700 }}>
                                                Percentage Above Estimate:
                                              </span>
                                              <br />
                                              <span
                                                style={{ color: "#495057" }}
                                              >
                                                {node.fields[8]?.value}
                                              </span>
                                            </p>
                                            <p className={auctionData}>
                                              <span style={{ fontWeight: 700 }}>
                                                Auction Year:
                                              </span>
                                              <br />
                                              <span
                                                style={{ color: "#495057" }}
                                              >
                                                {new Date(
                                                  node.fields[5].value
                                                ).getFullYear()}
                                              </span>
                                            </p>
                                            <p className={auctionData}>
                                              <span style={{ fontWeight: 700 }}>
                                                Artwork Size:
                                              </span>
                                              <br />
                                              <span
                                                style={{ color: "#495057" }}
                                              >
                                                {node.fields[2].value}
                                              </span>
                                            </p>
                                            <p className={auctionData}>
                                              <span style={{ fontWeight: 700 }}>
                                                Auction House:
                                              </span>
                                              <br />
                                              <span
                                                style={{ color: "#495057" }}
                                              >
                                                {node.fields[7].value}
                                              </span>
                                            </p>
                                            <p className={auctionData}>
                                              <span style={{ fontWeight: 700 }}>
                                                Location:
                                              </span>
                                              <br />
                                              <span
                                                style={{ color: "#495057" }}
                                              >
                                                {node.fields[6].value}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </Slider>
                                <br />
                                <br />
                                <FsLightbox
                                  toggler={toggler}
                                  sources={lightboxSources}
                                />
                              </div>
                            )
                          }
                        }
                        return null
                      })}
                      <br />
                    </div>
                  )}
                </div>
              )}
          </>
        ) : (
          ""
        )}

        <div className={sectionMandatPad}>
          <div className={saumlContainer}>
            <h1 className={title}>EXHIBITIONS</h1>
            <div>
              <Slider {...exhibitionsliderSettings}>
                {exhibitionsWithTwoFields.map((exhibition, index) => (
                  <div key={index}>
                    <div>
                      <br />
                      <h3>{exhibition.fields[1]?.value}</h3>
                      <ShopifyRichText
                        richTextData={exhibition.fields[0]?.value}
                      />
                      <br />
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export const Head = ({ data, pageContext }) => {
  const product = data.storefront.products.nodes.find(
    (node) => node.handle === pageContext.handle
  )

  return <Seo title={product.title} />
}

export const query = graphql`
  query SingleProduct {
    storefront {
      products(first: 250) {
        nodes {
          handle
          descriptionHtml
          createdAt
          availableForSale
          id
          isGiftCard
          onlineStoreUrl
          publishedAt
          requiresSellingPlan
          tags
          title
          totalInventory
          vendor
          images(first: 250) {
            nodes {
              height
              url
              altText
            }
          }
          variants(first: 1) {
            nodes {
              sku
            }
          }
          subheading: metafield(
            key: "product_subheading"
            namespace: "custom"
          ) {
            value
            updatedAt
            reference {
              ... on Storefront_Metaobject {
                id
                fields {
                  value
                }
              }
            }
          }
          advisoryInformation: metafields(
            identifiers: { key: "advisory_information", namespace: "custom" }
          ) {
            id
            reference {
              ... on Storefront_Metaobject {
                id
                framingData: field(key: "framing_data") {
                  value
                }
                valuationsData: field(key: "valuations_data") {
                  value
                }
                managementFeeData: field(key: "management_fees_data") {
                  value
                }
                valueOfWorkData: field(key: "value_of_work_data") {
                  value
                }
                totalCostofPortfolioIncludingSundriesData: field(
                  key: "total_cost_of_portfolio_including_sundries_data"
                ) {
                  value
                }
                rentalTermsData: field(key: "rental_terms") {
                  value
                }
                rentalreturnData: field(key: "rental_returns") {
                  value
                }
              }
            }
          }
          medium: metafield(key: "artwork_medium", namespace: "custom") {
            references(first: 250) {
              nodes {
                ... on Storefront_Metaobject {
                  id
                  fields {
                    value
                  }
                }
              }
            }
          }
          display_add_to_cart: metafield(
            key: "display_add_to_cart"
            namespace: "custom"
          ) {
            value
          }
          artworksubstrate: metafield(
            key: "artwork_substrate"
            namespace: "custom"
          ) {
            reference {
              ... on Storefront_Metaobject {
                id
                fields {
                  value
                }
              }
            }
          }
          dimension: metafield(key: "product_dimensions", namespace: "custom") {
            reference {
              ... on Storefront_Metaobject {
                id
                fields {
                  value
                }
              }
            }
          }
          Locationview: metafields(
            identifiers: {
              key: "where_is_artwork_available_to_view_"
              namespace: "custom"
            }
          ) {
            id
            createdAt
            reference {
              ... on Storefront_Metaobject {
                id
                fields {
                  value
                }
              }
            }
          }
          metafield(key: "select_template", namespace: "custom") {
            value
            updatedAt
            reference {
              ... on Storefront_Metaobject {
                id
                fields {
                  value
                }
              }
            }
          }
          metafields(
            identifiers: [{ namespace: "custom", key: "what_artworks_says" }]
          ) {
            createdAt
            reference {
              ... on Storefront_Metaobject {
                id
                fields {
                  reference {
                    ... on Storefront_Video {
                      id
                      sources {
                        url
                      }
                      alt
                    }
                    ... on Storefront_MediaImage {
                      id
                      image {
                        url
                        altText
                      }
                    }
                  }
                  value
                }
              }
            }
          }
        }
      }
      collections(first: 250) {
        nodes {
          descriptionHtml
          id
          title
          handle
          image {
            url
            altText
          }
          auction_results: metafields(
            identifiers: { key: "auction_results", namespace: "custom" }
          ) {
            id
            references(first: 250) {
              nodes {
                ... on Storefront_Metaobject {
                  auction_date: field(key: "auction_date") {
                    value
                  }
                  artwork_title_and_year: field(key: "artwork_title_and_year") {
                    value
                  }
                  artwork_auction_estimated_price: field(
                    key: "artwork_auction_estimated_price"
                  ) {
                    value
                  }
                  percentage_above_estimate: field(
                    key: "percentage_above_estimate"
                  ) {
                    value
                  }
                  artwork_auction_hammer_price: field(
                    key: "artwork_auction_hammer_price"
                  ) {
                    value
                  }
                  auction_house_name: field(key: "auction_house_name") {
                    value
                  }
                  auction_house_location_of_auctioneer: field(
                    key: "auction_house_location_of_auctioneer"
                  ) {
                    value
                  }
                  artwork_size: field(key: "artwork_size") {
                    value
                  }
                  auction_artwork_image: field(key: "auction_artwork_image") {
                    value
                  }
                  id
                }
              }
            }
          }
          metafields(
            identifiers: [
              { namespace: "custom", key: "explore_artist_by" }
              { namespace: "custom", key: "artist_format" }
              { namespace: "custom", key: "artist_career_stages" }
              { namespace: "custom", key: "artist_region" }
              { namespace: "custom", key: "collection_related_to_artist" }
              { namespace: "custom", key: "similar_artists" }
              { namespace: "custom", key: "is_this_an_artist_collection" }
              { namespace: "custom", key: "pdf" }
            ]
          ) {
            namespace
            key
            value
            references(first: 250) {
              nodes {
                ... on Storefront_Metaobject {
                  handle
                  fields {
                    value
                    reference {
                      ... on Storefront_MediaImage {
                        id
                        image {
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
            reference {
              ... on Storefront_Metaobject {
                handle
                field(key: "artists_photo") {
                  reference {
                    ... on Storefront_MediaImage {
                      image {
                        url
                        altText
                      }
                    }
                  }
                }
                pdfFile: field(key: "pdf") {
                  key
                  reference {
                    ... on Storefront_GenericFile {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
      metaobjects(first: 250, type: "artists_list") {
        nodes {
          handle
          fields {
            key
            type
          }
          exhibition: field(key: "exhibition") {
            references(first: 250) {
              nodes {
                ... on Storefront_Metaobject {
                  id
                  handle
                  fields {
                    type
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
